import type { ReactNode } from 'react'
import styles from './Checkout.module.css'

export interface CheckoutProps {
  children?: ReactNode
}

export function Checkout({ children }: CheckoutProps) {
  return <div className={styles.root}>{children}</div>
}
